import { memo, useEffect } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

import { useSnackbar, VariantType } from 'notistack';
import { useSearchParams } from 'react-router-dom';
import { LandingSnackbarTranslations } from './use-landing-snackbar.translations';

const SNACKBAR_INTENT_KEY = 'snackbar_intent';

type SnackbarIntent = {
  key: string;
  translation: MessageDescriptor;
  variant?: VariantType;
};

const INTENTS: SnackbarIntent[] = [{ key: 'draft_saved', translation: LandingSnackbarTranslations.draftSaved }];

export const useLandingSnackbar = () => {
  const { formatMessage } = useIntl();
  const { enqueueSnackbar: snackbar } = useSnackbar();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.has(SNACKBAR_INTENT_KEY)) return;

    const intent = INTENTS.find(({ key }) => key === searchParams.get(SNACKBAR_INTENT_KEY));
    if (intent) snackbar(formatMessage(intent.translation), { variant: intent.variant || 'success' });

    setSearchParams((sb) => {
      sb.delete(SNACKBAR_INTENT_KEY);
      return sb;
    });
  }, []);
};

export const LandingSnackbarCaller = memo(() => {
  useLandingSnackbar();
  return null;
});
